import api from './api';

export interface JurisprudenceSearchResult {
  id: number;
  pandora_id: string;
  title: string;
  court_name: string;
  judging_body?: string;
  judgment_date?: string;
  ementa: string;
  binding_thesis?: string;
  summary?: string;
  legal_domain?: string;
  legal_category?: string;
  keywords?: string[];
  cnj_number?: string;
  case_number?: string;
  quality_score?: number;
}

export interface JurisprudenceDetail extends JurisprudenceSearchResult {
  main_text?: string;
  tags?: string[];
}

/**
 * Busca jurisprudências por termo
 */
export const searchJurisprudence = async (
  query: string,
  filters?: {
    court_name?: string;
    legal_domain?: string;
    skip?: number;
    limit?: number;
  }
): Promise<{ total: number; skip: number; limit: number; items: JurisprudenceSearchResult[] }> => {
  const params: any = { query, ...filters };
  const response = await api.get('/jurisprudence-validated/search', { params });
  return response.data;
};

/**
 * Busca jurisprudências por área do direito
 */
export const getJurisprudenceByArea = async (
  legal_domain: string,
  skip: number = 0,
  limit: number = 10
): Promise<{ total: number; skip: number; limit: number; legal_domain: string; items: JurisprudenceSearchResult[] }> => {
  const response = await api.get('/jurisprudence-validated/by-area', {
    params: { legal_domain, skip, limit },
  });
  return response.data;
};

/**
 * Obtém detalhes de uma jurisprudência
 */
export const getJurisprudenceDetail = async (id: number): Promise<JurisprudenceDetail> => {
  const response = await api.get(`/jurisprudence-validated/${id}`);
  return response.data;
};

/**
 * Lista tribunais disponíveis
 */
export const listCourts = async (): Promise<string[]> => {
  const response = await api.get('/jurisprudence-validated/courts/list');
  return response.data.courts;
};

/**
 * Lista áreas do direito disponíveis
 */
export const listLegalDomains = async (): Promise<string[]> => {
  const response = await api.get('/jurisprudence-validated/domains/list');
  return response.data.domains;
};





